import axios from 'axios'
import store from '@store/index'
import { setAuthStatus } from '@store/slices/app-slice'

const interceptorService = {
  setup: () => {
    axios.interceptors.response.use(
      response => response,
      async error => {
        if (error.response && [401].includes(error.response.status)) {
          store.dispatch(setAuthStatus(false))
        }
        return Promise.reject(error)
      },
    )
  },
}

export default interceptorService
